module.exports = new __parcel__URL__("floor-sm.a8470298.jpg").toString();